/* eslint-disable prefer-template */
/* eslint-disable no-unneeded-ternary */
/* eslint-disable no-unused-vars */
/* eslint-disable consistent-return */
/* eslint-disable react/prop-types */
import React, { useEffect } from 'react';
import { List, Typography, useTheme, ListItemButton, ListItemIcon, ListItemText, Box } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { NavLink, useNavigate } from 'react-router-dom';
import { makeStyles } from '@mui/styles';
import { useSelector } from 'react-redux';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import RadioButtonUncheckedIcon from '@mui/icons-material/RadioButtonUnchecked';
import PlayCircleOutlineIcon from '@mui/icons-material/PlayCircleOutline';
import './scrollStyle.css';
import adminServices from '../../services/adminServices';
import { useMobileRestriction } from '../../hooks/useResponsive';
import MobileRestrictionDialog from '../../components/modal/MobileRestrictionDialog';

// eslint-disable-next-line no-unused-vars
const LinkBtn = React.forwardRef((props, ref) => <NavLink to={props.to} {...props} innerRef={ref} />);

const useStyles = makeStyles(() => ({
  listItem: {
    borderBottom: '1px solid #BCBCBC',
    padding: 12,
    "&:hover": {
      color: "#fff"
    }
  },
  skillIqTest: {
    padding: '4px 14px',
    borderRadius: '6px',
    margin: 'auto',
    border: '1px solid #FE7000',
    width: 'max-content',
    marginTop: '1rem',
    cursor: 'pointer',
  },

}));

const TopicList = ({ data, onClickCallBack, onReferenceButtonClick, onVideoClick, selectedIndex, submoduleId, location, subModuleName, status, screens, CallBackSkillSetIq, Modid, onProgressUpdate ,userId,  activeStep, activeTopic }) => { 
  const classes = useStyles();
  const theme = useTheme();
  const navigate = useNavigate();
  const userRole = useSelector((state) => state.userInfo?.role);
  const details = useSelector((state) => state.userInfo)

  const { t } = useTranslation('translation');
  const [selectedItemId, setSelectedItemId] = React.useState(data && data[0]?.id);
  const [isSmallScreen, setIsSmallScreen] = React.useState(window.innerWidth <= 600);
  
  const [authors, setAuthors] = React.useState([]);
  const [showMobileRestrictionDialog, setShowMobileRestrictionDialog] = React.useState(false);
  const isMobile = useMobileRestriction();

  useEffect(() => {
    getAuthors()
  }, [])

 

useEffect(() => {
  const handleResize = () => setIsSmallScreen(window.innerWidth <= 600);
  window.addEventListener('resize', handleResize);
  return () => window.removeEventListener('resize', handleResize);
}, []);
  
  const getAuthors = async () => {
    try {
      const response = await adminServices.getAuthors();

      if (response?.ok && Array.isArray(response.data)) {
        const authArray = response.data.map((a) => a.name);
        setAuthors(authArray);
        return true;
      }
    } catch (error) {
      console.error('Error fetching authors:', error);
    }
  };

  React.useMemo(() => {
    setSelectedItemId(selectedIndex)
  }, [selectedIndex])

const getFinalStatus = (item) => {
  let finalStatus = item?.screenProgress;

  if (item?.screenProgress === "completed" || item?.isCompleted === true) {
    finalStatus = "completed";
  } else if (item?.screenProgress === "inprogress") {
    finalStatus = "inprogress";
  } else if (item?.screenProgress === "not_started") {
    try {
      if (userId) {
        const storageKey = `topic_progress_${userId}`;
        const localProgress = JSON.parse(localStorage.getItem(storageKey)) || {};
        if (localProgress[item.id] === "inprogress") {
          finalStatus = "inprogress";
        }
      }
    } catch (error) {
      console.error('Failed to read localStorage progress:', error);
    }
  }
  return finalStatus;
};

const getMobileSubtitle = (item) => {
  if (item?.id === 'skillset') {
    const qCount = item?.question_list?.length;
    return `Diagnostic Exam${qCount ? ` · ${qCount} Qs` : ''}`;
  }
  if (item.actionType?.code === 'VIDEO') {
    return `Video Lesson${item?.duration ? ` · ${item.duration}` : ''}`;
  }
  if (item.actionType?.code === 'REFERENCE') {
    return 'Reference';
  }
  return item?.type || 'Practice Screen';
};

const renderMobileStatusIcon = (item) => {
  const finalStatus = getFinalStatus(item);
  if (finalStatus === "completed") {
    return <CheckCircleIcon sx={{ color: '#2fa360', fontSize: 22 }} />;
  }
  if (item.actionType?.code === 'VIDEO') {
    return <PlayCircleOutlineIcon sx={{ color: '#bbb', fontSize: 22 }} />;
  }
  return <RadioButtonUncheckedIcon sx={{ color: '#ccc', fontSize: 22 }} />;
};

  const renderProgressLabel = (item, index) => {
    if (item?.id === 'video') {
      return null;
    }
    let label = '';
    let background = '';
    let color = '';
    let finalStatus = item?.screenProgress;

    if (item?.screenProgress === "completed" || item?.isCompleted === true) {
      finalStatus = "completed";
    }
    else if (item?.screenProgress === "inprogress") {
      finalStatus = "inprogress";
    }
    else if (item?.screenProgress === "not_started") {
      try {
        if (userId) {
          const storageKey = `topic_progress_${userId}`;
          const localProgress = JSON.parse(localStorage.getItem(storageKey)) || {};
          if (localProgress[item.id] === "inprogress") {
            finalStatus = "inprogress";
          }
        }
      } catch (error) {
        console.error('Failed to read localStorage progress:', error);
      }
    }

    if (finalStatus === "completed") {
      label = 'Completed';
      background = '#a8e0c5';
      color = '#408655';
    } else if (finalStatus === "inprogress") {
      label = 'In Progress';
      background = '#FFE0B2';
      color = '#E65100';
    } else {
      label = 'Not Started';
      background = '#f5f5f5';
      color = '#666666';
    }

    if (!label) return null;

    return (
      <span style={{
        background,
        color,
        padding: '2px 8px',
        marginLeft: '8px',
        borderRadius: '12px',
        fontSize: '10px',
        fontWeight: '500',
        minWidth: '75px',
        border: '1px solid',
      }}>
        {label}
      </span>
    );
  };


const renderDesktopRow = (item, index, isSelected, isCompleted) => (
  <ListItemButton
    className={classes.listItem}
    selected={isSelected}
    onClick={status ? (event) => handleListItemClick(event, index, item) : undefined}
    key={`topic-${index}`}
    sx={{
      color: isCompleted ? theme.palette.secondary.main : theme.palette.grey[500],
      scrollSnapAlign: isSelected ? 'start' : 'none',
      scrollMargin: isSelected ? '100px' : '0px',
      fontSize: '12px',
      '&.Mui-selected': {
        color: "#111",
        fontWeight: '600',
        backgroundColor: "#a8e0c5"
      },
      '&.Mui-selected:hover': {
        color: "#FE7000",
        backgroundColor: "#a8e0c5"
      },
      '&:hover': {
        backgroundColor: "#00B673"
      },
    }}
  >
    <ListItemIcon />
    <ListItemText
      primary={
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <span>{item.courseSubmoduleTopics}</span>
          {item?.id !== "reference" && item?.id !== "skillset" && userRole !== 'SUPER_ADMIN' && userRole !== 'CONTENT_WRITER' && renderProgressLabel(item, index)}
        </div>
      }
      primaryTypographyProps={{
        style: {
          color: '#111',
          fontSize: '12px',
          lineHeight: '1.2'
        },
      }}
    />
  </ListItemButton>
);

const renderMobileRow = (item, index, isSelected) => (
  <ListItemButton
    selected={isSelected}
    onClick={status ? (event) => handleListItemClick(event, index, item) : undefined}
    key={`topic-mobile-${index}`}
    sx={{
      borderRadius: '12px',
      border: '1px solid #eee',
      marginBottom: '8px',
      padding: '10px 12px',
      '&.Mui-selected': {
        border: '1px solid #a8e0c5',
        backgroundColor: '#eafaf0',
      },
    }}
  >
    <ListItemIcon sx={{ minWidth: 36 }}>
      {renderMobileStatusIcon(item)}
    </ListItemIcon>
    <ListItemText
      primary={
        <Box sx={{ display: 'flex', flexDirection: 'column' }}>
          <Typography sx={{ fontSize: '14px', fontWeight: 600, color: '#111' }}>
            {item.courseSubmoduleTopics}
          </Typography>
          <Typography sx={{ fontSize: '12px', color: '#8a8a8a' }}>
            {getMobileSubtitle(item)}
          </Typography>
        </Box>
      }
    />
  </ListItemButton>
);

  const handleListItemClick = (event, index, item) => {
    const menuCheckbox = document.getElementById("menuCheckbox");
    if (menuCheckbox) {
      menuCheckbox.checked = !menuCheckbox.checked;
    }
    if (item.actionType?.code === 'VIDEO') {
      setSelectedItemId(item?.id);
      onVideoClick(item);
    } else if (item?.id === 'reference') {
      setSelectedItemId('reference');
      onReferenceButtonClick(submoduleId, subModuleName);
    } else if (item?.id === "skillset") {
     if (isMobile) {
        setShowMobileRestrictionDialog(true);
        return;
      }

      setSelectedItemId('skillset')

      const keyType = { actionType: data[0]?.actionType?.code === 'CODE' ? 'CODE' : 'HOTKEYS' };
      if (userRole === 'SUPER_ADMIN' || (authors)?.includes(details?.firstName + ' '+ details?.lastName)) {
        const path = ['AUTH_USER', 'SUPER_ADMIN', 'CONTENT_WRITER'].includes(userRole) ?
          `/app/skilliq-test?subModuleId=${submoduleId}` :
          `/auth/skilliq-test?subModuleId=${submoduleId}`;
        navigate(path, { state: { ...location.state, ...keyType, subModuleName } });
      }
      else {
        const val = { ...location.state, ...keyType, subModuleName, Modid }
        CallBackSkillSetIq(val)
      }


    }
    else {
      if (event.key === 'Enter') {
        console.log('Inside Enter...')
        return
      }
      if (event.key === ' ') {
        console.log('Inside space...')
        return
      }
      setSelectedItemId(item?.id);
      onClickCallBack(index, event);
    }
  };


  const renderIcon = (item) => {
    // return <VideoLibraryIcon sx={{ color: theme.palette.primary.main }} />;
    if (item === "SkillSet IQ") {
      return (
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: 24,
            height: 24,
            borderRadius: '50%',
            backgroundColor: theme.palette.common.white,
            border: `1px solid ${theme.palette.warning.main}`,
            color: theme.palette.warning.main,
            fontSize: '0.75rem',
          }}
        >
          <Typography variant="caption" component="span" sx={{ color: theme.palette.warning.main }}>
            {'Q'}
          </Typography>
        </Box>

      );
    }
    if (item !== "SkillSet IQ") {

      return <Box
        sx={{
          display: 'none',
          alignItems: 'center',
          justifyContent: 'center',
          width: 24,
          height: 24,
          borderRadius: '50%',
          backgroundColor: theme.palette.common.white,
          border: `1px solid ${theme.palette.warning.main}`,
          color: theme.palette.warning.main,
          fontSize: '0.75rem',
        }}
      >
        <Typography variant="caption" component="span" sx={{ color: theme.palette.warning.main }}>

          {item?.type ? item.type.charAt(0).toUpperCase() : "S"}

        </Typography>
      </Box>

    }
  };



  // SkillIq

  return (
    <>
      <List
        sx={{
          width: '100%',
          marginTop: 0,
          bgcolor: 'background.paper',
          paddingTop: '0',
          maxHeight: 'calc(100vh - 322px)',
          overflow: 'auto',
          overflowX: 'hidden',
          scrollbarWidth: 'thin',
          scrollSnapType: 'y proximity',
          scrollBehavior: 'smooth',
        }}
        component="nav"
        aria-labelledby="nested-list-subheader"
      >
        {data && data?.length > 0 && data.map((item, index) => {
          // const isSelected = selectedIndex === item.id;
          const isSelected = selectedItemId === item?.id;


          const { isCompleted } = item;

          const isReference = item.actionType?.code === 'REFERENCE';
          const isVideo = item.actionType?.code === 'VIDEO';

          // const serialNumber = getSerialNumber(item, index);
          const status = true;
           return isSmallScreen ? renderMobileRow(item, index, isSelected) : renderDesktopRow(item, index, isSelected, isCompleted);
          // return (
          //   <ListItemButton
          //     className={classes.listItem}
          //     // selected={isSelected}
          //     selected={isSelected}

          //     onClick={status ? (event) => handleListItemClick(event, index, item) : undefined}
          //     key={`topic-${index}`}
          //     sx={{
          //       color: isCompleted ? theme.palette.secondary.main : theme.palette.grey[500],
          //       scrollSnapAlign: isSelected ? 'start' : 'none',
          //       scrollMargin: isSelected ? '100px' : '0px',
          //       fontSize: '12px',
          //       '&.Mui-selected': {
          //         color: "#111",
          //         fontWeight: '600',
          //         backgroundColor: "#a8e0c5"
          //       },
          //       '&.Mui-selected:hover': {
          //         color: "#FE7000",
          //         // backgroundColor: theme.palette.secondary.lighter,     
          //         backgroundColor: "#a8e0c5"
          //       },
          //       '&:hover': {
          //         // backgroundColor: theme.palette.secondary.lighter,
          //         backgroundColor: "#00B673"
          //       },
          //     }}
          //   >
          //     <ListItemIcon>

          //       {/* {(isReference || isVideo) ? (
          //         <Box
          //           sx={{
          //             display: 'flex',
          //             alignItems: 'center',
          //             justifyContent: 'center',
          //             marginRight: '5px',
          //             marginLeft: '8px',
          //             color: '#111',

          //           }}
          //         >
          //           <Typography variant="caption" component="span">
          //             {serialNumber}.
          //           </Typography>
          //         </Box>
          //       ) : renderIcon(item)} */}
          //     </ListItemIcon>

          //     <ListItemText
          //       primary={
          //         <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          //           <span>{item.courseSubmoduleTopics}</span>
          //           {item?.id !== "reference" && item?.id !== "skillset" && userRole !== 'SUPER_ADMIN' && userRole !== 'CONTENT_WRITER' && renderProgressLabel(item, index)}

          //         </div>
          //       }
          //       primaryTypographyProps={{
          //         style: {
          //           color: '#111',
          //           fontSize: '12px',
          //           lineHeight: '1.2'
          //         },
          //       }}
          //     />
          //   </ListItemButton>
          // );
        })}



        {/* SkillSet IQ Item */}
        {/* <ListItemButton
          className={classes.listItem}
          onClick={status ? () => handleNavigateSkill() : undefined}
          sx={{
            marginTop: data && data.some(item => item.actionType?.code === 'REFERENCE') ? '0' : '8px',
            borderTop: data && data.some(item => item.actionType?.code === 'REFERENCE') ? 'none' : '1px solid #e0e0e0',
            color: theme.palette.grey[500],
            scrollSnapAlign: 'start',
            scrollMargin: '100px',
            '&.Mui-selected': {
              color: "#111",
              fontWeight: '600',
              backgroundColor: "#a8e0c5"   
            },
            '&.Mui-selected:hover': {       
              color: "#FE7000",        
              backgroundColor: "#a8e0c5"        
            },
            '&:hover': {
              backgroundColor: "#00B673"   
            },
          }}
        >
         
          <ListItemText id="SkillSetIQ" sx={{paddingLeft: '16px', color: '#111', fontSize: '14px !important'}} primary={t('SkillSet IQ')} />
        </ListItemButton> */}
      </List>



      {/* <Typography
        className={classes.skillIqTest}
        variant="subtitle1"
        onClick={() => {
          const keyType = { actionType: data[0]?.actionType?.code === 'CODE' ? 'CODE' : 'HOTKEYS' };
          const path = ['AUTH_USER', 'SUPER_ADMIN', 'CONTENT_WRITER'].includes(userRole) ?
            `/app/skilliq-test?subModuleId=${submoduleId}` :
            `/auth/skilliq-test?subModuleId=${submoduleId}`;

          navigate(path, { state: { ...location.state, ...keyType } });
        }}
        sx={{ textDecoration: 'none !important' }}
        color="primary"
      >
        SkillSet IQ
      </Typography> */}

      <MobileRestrictionDialog
        open={showMobileRestrictionDialog}
        onClose={() => setShowMobileRestrictionDialog(false)}
      />
    </>
  );
};

export default TopicList;
